import type { FC } from "react";

import type { INavigationModalActions } from "../common/NavigationModal";
import UserCommunicationTemplate from "../common/UserCommunicationTemplate";

import * as css from "./SuccessForm.module.css";

export type ISuccessForm = INavigationModalActions;

const SuccessForm: FC<ISuccessForm> = (props) => (
    <div className={css.successFormComponent}>
        <div className={css.innerContent}>
            {props.fieldValues && props.fieldValues.userCommunicationTemplate && (
                <UserCommunicationTemplate {...props.fieldValues.userCommunicationTemplate} />
            )}
        </div>
    </div>
);

export default SuccessForm;
